import { useEffect, useState } from 'preact/hooks';

import type { Partner } from './partner-types';
import Icon from './Icon';

const PartnerMap = lazy(() => import('./PartnerMap'));
import PartnerList from './PartnerList';

import { lazy, Suspense } from 'preact/compat';

type Props = {
	allPartners: Partner[];
};

type View = 'list' | 'map';

export default function PartnerNetwork({ allPartners }: Props) {
	const [view, setView] = useState<View>(getInitialView());
	const [mapViewed, setMapViewed] = useState(view === 'map');
	const [listViewed, setListViewed] = useState(view === 'list');

	useEffect(() => {
		const url = new URL(window.location.href);
		if (view === 'map') {
			url.searchParams.set('view', 'map');
		} else {
			url.searchParams.delete('map');
		}
		window.history.replaceState({}, '', url.toString());
	}, [view]);

	useEffect(() => {
		if (view === 'map') {
			setMapViewed(true);
		} else {
			setListViewed(true);
		}
	}, [view]);

	return (
		<>
			<div className="partner-network__view-buttons">
				<button
					className={`partner-network__view-button ${
						view === 'list' ? 'partner-network__view-button--active' : ''
					}`}
					onClick={() => setView('list')}
				>
					<Icon id="list" /> Listenansicht
				</button>{' '}
				<button
					className={`partner-network__view-button ${
						view === 'map' ? 'partner-network__view-button--active' : ''
					}`}
					onClick={() => setView('map')}
				>
					<Icon id="map" /> Kartenansicht
				</button>
			</div>
			<div className={`partner-network__main partner-network__main--${view}`}>
				{mapViewed && (
					<Suspense fallback={<strong>Karte wird geladen…</strong>}>
						<PartnerMap show={view === 'map'} allPartners={allPartners} />
					</Suspense>
				)}
				{listViewed && (
					<PartnerList show={view === 'list'} allPartners={allPartners} />
				)}
			</div>
		</>
	);
}

function getInitialView(): View {
	const url = new URL(window.location.href);
	const view = url.searchParams.get('view');

	return view === 'map' ? 'map' : 'list';
}
